import { useIsArticlePage } from "@src/app/hooks/useIsArticlePage";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import dayjs from "dayjs";

import { useCustomParams } from "./useCustomParams";

/**
 * @see https://docs.google.com/spreadsheets/d/1KpXevZuXuYmSs3LSnGtkWwCHIe3ijK15QfvEof17C6w/edit?gid=0#gid=0
 */
export default function useGAData() {
  const { level1 = "", level2 = "" } = useCustomParams();

  const isArticlePage = useIsArticlePage();
  const { article } = useRouteResponse("articlePage");

  const contenttype = isArticlePage ? "article" : "listing";
  const keyword = isArticlePage
    ? (article?.tags || []).map((tag) => tag.name).join(",")
    : "红蚂蚁，新加坡，新闻，评论，综述，假新闻，热词，辟谣，言论，文化，生活，观点，东南亚，狮城，交流，海外";
  const author = isArticlePage ? article?.authors[0]?.name || "" : "";
  const contentcat = "free";
  const articleid = isArticlePage ? article?.id || "" : "";
  const pubdate = isArticlePage
    ? article?.created
      ? dayjs(article.created).format("YYYY-MM-DD HH:mm:ss")
      : ""
    : "";
  const cd_version = "redants2";
  const visitorcat = "anonymous";

  return {
    gaLevel2: level1 || "home",
    chapter1: level2 || "",
    contenttype,
    keyword,
    author,
    contentcat,
    articleid,
    pubdate,
    cd_version,
    visitorcat,
    pagination: 1,
  };
}
